import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../../../assets/Logo.png";
import numberOfQualifiedLeads from "../../../../assets/number-of-qualified-leads.svg";
import { activeUser } from "../../../common/redux/actions";
import { PleaseWait } from "../../../common/components/PleaseWait";
import styled from "styled-components";

// Styled Components
const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  background-color: #f8f9fa;
`;

const SubContainer = styled.div`
  display: flex;
  width: 80%;
  max-width: 1200px;
  background-color: #000040;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background-color: rgb(255, 255, 255);

  @media (max-width: 768px) {
    display: none;
  }
`;

const FormWrapper = styled.div`
  flex: 1;
  padding: 60px 40px;
`;

const FormColumn = styled.div`
  max-width: 400px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 36px;
  color: rgb(255, 255, 255);
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormInput = styled.input`
  padding: 14px 16px;
  margin-bottom: 16px;
  border: 1px solid rgb(255, 0, 0);
  border-radius: 8px;
  background-color: #000040;
  font-size: 16px;
  color : white;
  transition: border-color 0.3s, box-shadow 0.3s;

  &:focus {
    outline: none;
    border-color: rgb(255, 135, 135);
    box-shadow: 0 0 0 3px rgba(86, 41, 182, 0.1);
  }

  &::placeholder {
    color: rgb(255, 255, 255);
  }
`;

const ButtonSuccessLarge = styled.button`
  padding: 14px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: rgb(255, 0, 0);
  color: white;
  border: none;
  margin-top: 36px;

  &:hover {
    background-color: rgb(215, 0, 0);
    transform: translateY(-2px);
  }
`;

const FormFooterLink = styled.div`
  text-align: center;
  margin-top: 16px;
  font-size: 14px;

  a {
    color: rgb(255, 255, 255);
    font-weight: 500;

    &:hover {
      text-decoration: underline !important;
    }
  }
`;

const Logo = styled.img`
  width: 125px;
  margin-bottom: 40px;
`;

const IllustrationImage = styled.img`
  width: 300px;
  max-width: 100%;
`;

class Registration extends Component {
  state = {
    signUp: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirm_password: "",
    },
    pleaseWaitLoading: false,
  };

  handlefirstnameChange = (event) => {
    let signUp = { ...this.state.signUp };
    signUp.firstName = event.currentTarget.value;
    this.setState({ signUp });
  };

  handleLastNameChange = (event) => {
    let signUp = { ...this.state.signUp };
    signUp.lastName = event.currentTarget.value;
    this.setState({ signUp });
  };

  handleEmailChange = (event) => {
    let signUp = { ...this.state.signUp };
    signUp.email = event.currentTarget.value;
    this.setState({ signUp });
  };

  handlePasswordChange = (event) => {
    let signUp = { ...this.state.signUp };
    signUp.password = event.currentTarget.value;
    this.setState({ signUp });
  };

  handleConfirmPasswordChange = (event) => {
    let signUp = { ...this.state.signUp };
    signUp.confirm_password = event.currentTarget.value;
    this.setState({ signUp });
  };

  handleAccessLevelSecret = (event) => {
    let signUp = { ...this.state.signUp };
    signUp.secretKey = event.currentTarget.value;
    this.setState({ signUp });
  };

  isPleaseWaitLoading = (type) => {
    this.setState({ pleaseWaitLoading: type });
  };

  SignUpFormSubmit = (event) => {
    try {
      event.preventDefault();
      this.props.propsToContainer(this.state.signUp, this.isPleaseWaitLoading);
      window.localStorage.setItem("signUp", JSON.stringify(this.state.signUp));
      this.setState({ pleaseWaitLoading: true });
    } catch (error) {
      console.log(error.message);
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.state.pleaseWaitLoading && (
          <PleaseWait position={"fixed"} width={"100%"} height={"100%"} />
        )}
        <MainContainer>
          <SubContainer>
            <ContentWrapper>
              <Logo src={logo} alt="logo" />
              <IllustrationImage
                className="chatBotSvg"
                src={numberOfQualifiedLeads}
                alt="Qualified Leads Illustration"
              />
            </ContentWrapper>
            <FormWrapper>
              <FormColumn>
                <Title>Sign Up</Title>
                <Form onSubmit={this.SignUpFormSubmit}>
                  <FormInput
                    type="text"
                    required
                    placeholder="First Name"
                    onChange={this.handlefirstnameChange}
                  />
                  <FormInput
                    type="text"
                    required
                    placeholder="Last Name"
                    onChange={this.handleLastNameChange}
                  />
                  <FormInput
                    type="email"
                    required
                    placeholder="Email Address"
                    onChange={this.handleEmailChange}
                  />
                  <FormInput
                    type="password"
                    required
                    placeholder="Password"
                    onChange={this.handlePasswordChange}
                  />
                  <FormInput
                    type="password"
                    required
                    placeholder="Confirm Password"
                    onChange={this.handleConfirmPasswordChange}
                  />
                  <FormInput
                    type="text"
                    placeholder="Secret Key (optional)"
                    onChange={this.handleAccessLevelSecret}
                  />
                  <ButtonSuccessLarge>Sign Up</ButtonSuccessLarge>
                  <FormFooterLink>
                    <Link to="/login">Have Credentials? Log in from here!</Link>
                  </FormFooterLink>
                </Form>
              </FormColumn>
            </FormWrapper>
          </SubContainer>
        </MainContainer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps, { activeUser })(Registration);
